import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileSticky from "../components/MobileSticky";
import QuoteForm from "../components/QuoteForm";
import Seo, { localBusinessSchema } from "../components/Seo";
import { COMPANY } from "../data/site";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <Seo
        title="Contact — Connolly's Painting Solutions"
        description="Get in touch with Connolly's Painting Solutions. Servicing the entire Sunshine Coast. Call 0401 437 582."
        path="/contact"
        schema={[localBusinessSchema(COMPANY)]}
      />
      <Header />

      <section className="section bg-[#F9F8F6]">
        <div className="container-cps grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline">Contact</div>
            <h1 className="font-display text-5xl md:text-6xl mt-4 tracking-tight">Get in touch.</h1>
            <p className="mt-6 text-[#4F5B6A] leading-relaxed">
              The fastest way to start is a phone call or our quote form — we respond to every enquiry within one business day.
            </p>

            <div className="hairline-gold my-10" />

            <div className="space-y-5">
              <a href={`tel:${COMPANY.phoneTel}`} className="flex items-center gap-4 text-[#0B1426] hover:text-[#C5A059]" data-testid="contact-phone">
                <Phone size={18} />
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#4F5B6A]">Phone</div>
                  <div className="font-display text-xl">{COMPANY.phone}</div>
                </div>
              </a>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-4 text-[#0B1426] hover:text-[#C5A059]" data-testid="contact-email">
                <Mail size={18} />
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#4F5B6A]">Email</div>
                  <div className="text-base">{COMPANY.email}</div>
                </div>
              </a>
              <div className="flex items-center gap-4 text-[#0B1426]">
                <MapPin size={18} />
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#4F5B6A]">Service area</div>
                  <div className="text-base">Entire Sunshine Coast, QLD</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-[#0B1426]">
                <Clock size={18} />
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#4F5B6A]">Hours</div>
                  <div className="text-base">{COMPANY.hours}</div>
                </div>
              </div>
            </div>

            <div className="mt-10 border border-[#E5E3DB]" data-testid="contact-map">
              <iframe
                title="Sunshine Coast service area"
                src="https://www.google.com/maps?q=Sunshine%20Coast%20QLD&output=embed"
                className="w-full h-64"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="lg:col-span-7 bg-white p-8 md:p-12 border border-[#E5E3DB]">
            <div className="overline">Send a message</div>
            <h2 className="font-display text-3xl md:text-4xl mt-3 mb-8 tracking-tight">Tell us about your project.</h2>
            <QuoteForm sourcePage="contact" />
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </div>
  );
}
